import { forwardRef } from "react";
import { selectVariants } from "@markeroo/theme";

export interface SelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  /** Additional CSS classes to apply */
  className?: string;
}

/**
 * Select component with consistent styling from the design system.
 *
 * Features:
 * - Proper focus-visible ring (not default browser outline)
 * - Custom caret icon
 * - Cursor pointer for better UX
 *
 * Usage:
 * ```tsx
 * import { Select } from "@markeroo/ui";
 *
 * <Select value={value} onChange={handleChange}>
 *   <option value="1">Option 1</option>
 *   <option value="2">Option 2</option>
 * </Select>
 * ```
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className = "", ...props }, ref) => {
    return (
      // eslint-disable-next-line no-restricted-syntax -- This IS the Select component implementation
      <select
        ref={ref}
        className={`${selectVariants.default} ${className}`}
        {...props}
      />
    );
  }
);

Select.displayName = "Select";
